import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Container, Text } from 'theme-ui'

import { WithTheme } from '../../../setup/index'
import { transition } from '../../../common/Mixins'
import media from '../../../common/MediaQueries'
import { WebinarsAccordionStylesProps } from './types'

export const WebinarsAccordionStyled = styled.div``

export const WebinarsAccordionInnerStyled = styled.div`
  display: flex;
`

export const WebinarsAccordionContentStyled = styled(Container)`
  width: 100%;
`

export const WebinarsAccordionContentContainerStyled = styled.div<WithTheme<WebinarsAccordionStylesProps>>`
  width: 100%;
  padding: 1.25rem 0.875rem 1.25rem 1.25rem;
  border-radius: 0.625rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.02);
  cursor: pointer;
  &:not(:last-of-type) {
    margin-bottom: 2rem;
  }

  @media ${media.phone} {
    padding: 2rem 2rem 1.875rem 3rem;

    &:not(:last-of-type) {
      margin-bottom: 2.375rem;
    }
  }
`

export const WebinarsAccordionContentItemStyled = styled.div<WithTheme<WebinarsAccordionStylesProps>>`
  ${transition}
  display: none;
  opacity: 0;
  margin-top: 2rem;
  transition-duration: 280ms;
  width: 100%;

  ${({ isActive }) =>
    isActive &&
    css`
      display: block;
    `};

  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-left: 3rem;' : 'padding-right: 3rem;')};
  }
`

export const WebinarsAccordionContentTextStyled = styled.div<WithTheme>`
  width: 100%;
  max-width: 640px;
`

export const WebinarsAccordionContentDescStyled = styled(Text)<WithTheme>`
  font-weight: 500;
  margin-bottom: 24px;
`

export const WebinarsAccordionContentListHeadStyled = styled(Text)<WithTheme>`
  color: ${({ theme }) => theme.colors.blue};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: 24px;
`

export const WebinarsAccordionContentListStyled = styled.ul`
  padding-left: 5px;
  margin-bottom: 20px;
`

export const WebinarsAccordionContentListItemStyled = styled.li`
  font-size: 0.9375rem;

  font-weight: 500;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &:before {
    content: '-';
    margin-right: 5px;
  }

  @media ${media.phone} {
    font-size: 1.125rem;
  }
`

export const WebinarsAccordionContentCtaStyled = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
`

export const WebinarsAccordionHeadTextStyled = styled(Text)<WithTheme>`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  @media ${media.maxTablet} {
    width: 90%;
    order: 1;
  }

  @media ${media.tablet} {
    padding-right: 5rem;
    max-width: 920px;
    flex: 1;
  }
`

export const WebinarsAccordionHeadAdditionalsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media ${media.maxPhoneSmall} {
    flex-direction: column;
  }

  @media ${media.maxTablet} {
    width: 100%;
    order: 3;
    margin-top: 28px;
  }
  @media ${media.tablet} {
    flex: 1;
  }
`

export const WebinarsAccordionHeadAdditionalsItemStyled = styled.div`
  flex: 1;

  &:not(:last-child) {
    margin-right: 2rem;
  }

  @media ${media.maxPhoneSmall} {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
`

export const WebinarsAccordionHeadIconStyled = styled.div<WithTheme>`
  display: flex;
  align-items: center;
  padding-bottom: 0.125rem;
  color: ${({ theme }) => theme.colors.green};

  svg {
    ${transition};
    height: 1.25rem;
    font-size: 1rem;
    width: 1.125rem;
    transform: rotate(180deg);
    @media ${media.phone} {
      font-size: 1rem;
      width: 1.625rem;
    }
  }

  @media ${media.maxTablet} {
    order: 2;
    svg {
      height: 1rem;
    }
  }

  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 3.125rem;' : 'padding-left: 3.125rem;')}
  }
`

export const WebinarsAccordionHeadStyled = styled.div<WithTheme<WebinarsAccordionStylesProps>>`
  ${transition};
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.black};

  @media ${media.maxTablet} {
    flex-wrap: wrap;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      ${WebinarsAccordionHeadIconStyled} {
        svg {
          transform: rotate(270deg);
        }
      }
    `};
`
